const events = [
  {
    id: 9,
    title: 'La Fiesta 5.0',
    cardSize: 'large',
    displayOrder: 1,
    category: 'Inclusion',
    date: 'Apr 24–25, 2026',
    location: 'Main Auditorium & Fete Area',
    attendeesNote: '1500 attended',
    description:
      'Youth United\'s flagship celebration brought together children from the Deaf and Blind School, Masti Ki Pathshala, and Government High School, Thuhi for creative activities, performances, carnival games, and a light-and-sound show.',
    icon: 'fa-solid fa-universal-access',
    image: '/images/events/LA_FIESTA_image_19.jpg',
    imagePosition: 'lower-middle',
  },
  {
    id: 1,
    title: 'La Fiesta 4.0',
    cardSize: 'medium',
    displayOrder: 5,
    category: 'Inclusion',
    date: 'Apr 18, 2025',
    location: 'Main Auditorium',
    attendeesNote: '42+ participated',
    description:
      'A joyful celebration for differently-abled children from schools and NGOs across Patiala, featuring drawing, clay modelling, singing, and dancing at the Main Auditorium.',
    icon: 'fa-solid fa-universal-access',
    image: '/images/events/la-fiesta-5.jpg',
  },
  {
    id: 2,
    title: 'Society Fair 2025',
    cardSize: 'small',
    displayOrder: 7,
    category: 'Outreach',
    date: 'Aug 24, 2025',
    location: 'Thapar Campus',
    attendeesNote: 'Batch of 2029',
    description:
      'Youth United showcased its culture at the Frosh Society Fair with interactive stalls, a custom dice game, and a "Pick One and Leave One" board to engage the batch of 2029.',
    icon: 'fa-solid fa-bullhorn',
    image: '/images/events/society-fair.jpg',
  },
  {
    id: 3,
    title: 'Orientation Program 2025',
    cardSize: 'small',
    displayOrder: 8,
    category: 'Community',
    date: 'Sep 1, 2025',
    location: 'TAN Building, T106',
    attendeesNote: '150+ attended',
    description:
      'A vibrant orientation for new members featuring the "Question to a Question" icebreaker, a Menti Quiz, departmental introductions, and a closing music jamming session.',
    icon: 'fa-solid fa-people-group',
    image: '/images/events/orientation.jpg',
  },
  {
    id: 4,
    title: 'Air Force Cycle Rally',
    cardSize: 'small',
    displayOrder: 9,
    category: 'Environment',
    date: 'Nov 13, 2025',
    location: 'Thapar Campus',
    attendeesNote: '100+ attended',
    description:
      "Cyclists rode from Chandigarh to Patiala promoting eco-friendly transport. Volunteers welcomed them on campus and toured Thapar's Recycling Plant to learn about waste management.",
    icon: 'fa-solid fa-bicycle',
    image: '/images/events/brd.jpg',
  },
  {
    id: 5,
    title: 'Utsav-e-Solace',
    cardSize: 'medium',
    displayOrder: 10,
    category: 'Social Impact',
    date: 'Oct 27 – Nov 9, 2025',
    location: 'Campus & Patiala City',
    attendeesNote: '400+ engaged',
    description:
      'A donation drive with the Rotaract Club collecting clothes, shoes, and toys via a Wall of Kindness, distributed to Sai Bridh Ashram, Masti Ki Pathshala, and slum communities.',
    icon: 'fa-solid fa-hand-holding-heart',
    image: '/images/events/utsav-e-solace.jpg',
  },
  {
    id: 6,
    title: 'Unity March – Sardar@150',
    cardSize: 'small',
    displayOrder: 11,
    category: 'Unity',
    date: 'Nov 17, 2025',
    location: 'Patiala City',
    attendeesNote: '108 participated',
    description:
      "Volunteers joined a district-level padyatra from Quila Mubarak Chowk to Kali Mata Mandir to commemorate Sardar Vallabhbhai Patel's 150th birth anniversary.",
    icon: 'fa-solid fa-people-arrows',
    image: '/images/events/unity-march.jpg',
  },
  {
    id: 7,
    title: 'Run for Swadeshi',
    cardSize: 'small',
    displayOrder: 12,
    category: 'Youth',
    date: 'Jan 12, 2026',
    location: 'Thapar Campus',
    attendeesNote: '170–180 participated',
    description:
      'On National Youth Day, Youth United with NCC and NSS organized the Swadeshi Sankalp Run with a speaker session on Swami Vivekanand\'s ideals of self-reliance and national pride.',
    icon: 'fa-solid fa-person-running',
    image: '/images/events/run-for-swadeshi.jpg',
  },
  {
    id: 8,
    title: 'UMANG 2026',
    cardSize: 'medium',
    displayOrder: 13,
    category: 'Children',
    date: 'Feb 14, 2026',
    location: 'K Lawns, Thapar',
    attendeesNote: '152 attended',
    description:
      'A heartfelt sports and fun day for children from Masti Ki Pathshala, featuring a Mini Game Zone, face painting, traditional games like Kho-Kho and Pithu, and a cake-cutting ceremony.',
    icon: 'fa-solid fa-child-reaching',
    image: '/images/events/umang.jpg',
  },
  {
    id: 10,
    title: 'STEM Conclave 2026',
    cardSize: 'small',
    displayOrder: 2,
    category: 'STEM',
    date: 'Apr 18, 2026',
    location: 'Thapar Institute of Engineering and Technology',
    attendeesNote: '100 selected girls',
    description:
      'A day-long learning experience organized by Avanti Fellows and Sanjhi Sikhiya, with Youth United volunteers, exposing young girls to coding, engineering, innovation, and hands-on electronics.',
    icon: 'fa-solid fa-microchip',
    image: '/images/events/STEM_CONCLAVE_image_05.jpg',
  },
  {
    id: 11,
    title: 'Society Fair 2026',
    cardSize: 'small',
    displayOrder: 3,
    category: 'Outreach',
    date: 'Aug 19, 2026',
    location: 'FETE Area, Thapar Institute',
    attendeesNote: 'Batch of 2030',
    description:
      'Youth United introduced its work to the incoming Batch of 2030 through an interactive stall with games, a photobooth, creative displays, and direct student engagement.',
    icon: 'fa-solid fa-bullhorn',
    image: '/images/events/society-fair-2026-07.png',
  },
  {
    id: 12,
    title: 'Orientation Program 2026',
    cardSize: 'small',
    displayOrder: 4,
    category: 'Community',
    date: 'Aug 22, 2026',
    location: 'TAN Auditorium',
    attendeesNote: 'Batch of 2030',
    description:
      'An engaging welcome for the incoming Batch of 2030 combining a Youth United introduction, Menti quiz, performances, student participation, and an open dance session.',
    icon: 'fa-solid fa-people-group',
    image: '/images/events/orientation-2026-08.png',
  },
];

export default events;
